import { FC } from 'react'
import { HeapScript } from '../../../components/head/scripts/heap'
import { ImpactUttHeadScript } from './Impact'
import {
  NBA_TAG_CONTAINER_URL,
  NBA_USER_CONSENT_URL,
  NBA_WIDGET_URL
} from '@app/page/src/components/widgets/__NBAIdGate/NBAIdWidget.constants'
import { Routes } from '@dtx-company/true-common/src/constants/routes'

export const AppHeadContents: FC<{
  pathname: string
  page?: { links: { type: string }[] }
}> = ({ pathname, page }) => {
  const isFlowpage = pathname === Routes.FLOWPAGE
  const hasNBAWidget = page?.links?.some(link => link.type === 'nbaIdGate')

  return (
    <>
      {isFlowpage ? (
        <>
          {/* Add checks for additional 3rd party gate widget scripts here */}
          {hasNBAWidget && (
            <>
              {/* eslint-disable-next-line @next/next/no-sync-scripts */}
              <script // NBA "User Consent" Script
                src={NBA_USER_CONSENT_URL}
              />
              <script src={NBA_TAG_CONTAINER_URL} async />
              <script // NBA ID Widget
                data-testid="nba-id-widget"
                async
                src={NBA_WIDGET_URL}
              />
            </>
          )}
        </>
      ) : (
        <>
          <HeapScript />
          <ImpactUttHeadScript />
        </>
      )}
    </>
  )
}
